var _path, _path2, _path3, _path4, _path5, _polygon, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileJpeg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 48",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "jpegTitle"
  }, "JPEG File") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "jpegTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-0.1-0.1v48h23c7.2 0 13-5.8 13-13v-35h-36zm34 35c0 6.1-4.9 11-11 11h-21v-44h32v33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.3 39.1 0.6-0.4c0.2 0.3 0.5 0.5 0.8 0.5 0.5 0 0.8-0.3 0.8-1v-3.5h1v3.6c0 1-0.5 1.8-1.6 1.8-0.8-0.1-1.3-0.4-1.6-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13.7 34.7h1.7c1.2 0 2 0.4 2 1.6s-0.9 1.7-2 1.7h-0.7v1.9h-1v-5.2zm1.7 2.5c0.8 0 1.1-0.3 1.1-0.9s-0.4-0.9-1.2-0.9h-0.6v1.8h0.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m18.4 34.7h3.2v0.8h-2.2v1.3h1.9v0.8h-1.9v1.5h2.3v0.8h-3.2l-0.1-5.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m22.4 37.3c0-1.7 1.1-2.7 2.5-2.7 0.7 0 1.3 0.3 1.6 0.7l-0.5 0.6c-0.3-0.3-0.6-0.4-1-0.4-0.9 0-1.5 0.7-1.5 1.9s0.5 1.9 1.6 1.9c0.3 0 0.6-0.1 0.7-0.2v-1.1h-1v-0.8h1.8v2.3c-0.4 0.4-1 0.6-1.7 0.6-1.4-0.1-2.5-1.1-2.5-2.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "10.1 11.9 25.8 11.9 25.8 9.7 10.1 9.7"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.1 20.1 25.8 20.1 25.8 17.9 10.1 17.9"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.1 28.4 22.1 28.4 22.1 26.1 10.1 26.1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileJpeg);
export default __webpack_public_path__ + "static/media/file-jpeg.e0d04e23a05a3e96d6ed959ae035d0b2.svg";
export { ForwardRef as ReactComponent };